import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted, computed } from 'vue';
import videojs from 'video.js';
import Player from 'video.js/dist/types/player';
import 'videojs-mux';
import { IVideoMetadata } from '~/types/mux-player';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPlayerRawDCDN',
  props: {
    videoId: null,
    poster: null,
    thumbnailVtt: null,
    startTime: null,
    videoMetadata: null
  },
  emits: [
  'play',
  'pause',
  'seeked',
  'ended',
  'canplay',
  'mounted',
],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  videoId: string;
  poster: string;
  thumbnailVtt?: string;
  startTime?: number;
  videoMetadata?: Partial<IVideoMetadata>;
}





const videoPlayerRef = ref<HTMLVideoElement | null>(null);
const player = ref<Player | null>(null);

const source = computed(() => `${process.env.filmNodeEgress}/${props.videoId}`);

const muxDataEnvKey = process.env.dcdnMuxDataEnvKey;

function initializePlayer() {
  if (videoPlayerRef.value) {
    player.value = videojs(videoPlayerRef.value, {
      plugins: {
        mux: {
          debug: false,
          data: {
            env_key: muxDataEnvKey,
            ...props.videoMetadata,
            player_name: 'Gala-Film-DCDN-Player',
            player_version: '1.0.0',
            video_id: props.videoId,
          },
        },
      },
      fluid: true,
      html5: {
        vhs: {
          maxBufferLength: 60,
          bufferLowWaterLine: 10,
          bufferHighWaterLine: 30,
          maxBufferAhead: 30,
          maxBufferHole: 0.5,
          initialBandwidth: 500000,
          bandwidthSwitchUpscaleFactor: 1.5,
          bandwidthSwitchDownscaleFactor: 0.5,
          timeout: 60000,
          retryCount: 5,
          retryDelay: 2000,
          maxSegmentLength: 10,
        }
      }
    });

    player.value.fill(true);
    player.value.on('play', () => emit('play'));
    player.value.on('pause', () => emit('pause'));
    player.value.on('seeked', () =>
      emit('seeked', player.value!.currentTime()),
    );
    player.value.on('ended', () => emit('ended'));
    player.value.on('canplay', () => emit('canplay'));
    if (props.thumbnailVtt) {
      // Assuming you have the plugin for thumbnails
      // player.value.vttThumbnails({ src: props.thumbnailVtt });
    }
  }
}

function getVideoDuration() {
  if (player.value) {
    return player.value.duration();
  }
  return 0;
}

function getVideoCurrentTime() {
  if (player.value) {
    return player.value.currentTime();
  }
  return 0;
}

function isPaused() {
  if (player.value) {
    return player.value.paused();
  }
  return true;
}

function play() {
  player.value?.play();
}

function pause() {
  player.value?.pause();
}

function setCurrentTime(time: number) {
  if (player.value) {
    player.value.currentTime(time);
  }
}

expose({
  getVideoDuration,
  getVideoCurrentTime,
  isPaused,
  play,
  pause,
  setCurrentTime,
});

onMounted(() => {
  initializePlayer();
  emit('mounted');
});

onUnmounted(() => {
  if (player.value) {
    player.value.off('play');
    player.value.off('pause');
    player.value.off('seeked');
    player.value.off('ended');
    player.value.dispose();
  }
});

return { __sfc: true,props, emit, videoPlayerRef, player, source, muxDataEnvKey, initializePlayer, getVideoDuration, getVideoCurrentTime, isPaused, play, pause, setCurrentTime }
}

})